import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import HowItWorksModal from "../../components/ui/HowItWorksModal/HowItWorksModal";

// Actions (unchanged)
import { listYears } from "../../actions/yearActions";
import { listWeeks } from "../../actions/weekActions";
import { listDays } from "../../actions/dayActions";
import { logout } from "../../actions/userActions";

// Components (unchanged)
import Header from "../../components/layouts/Header/Header";
import TestFooter from "../../components/layouts/Footer/TestFooter";

// Import the new stylesheet
import "./profile_menu.css";

export default function ProfileMenuScreen({ history }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // --- All existing hooks and logic are preserved ---
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const yearList = useSelector((state) => state.yearList);
  const { years } = yearList;

  const weekList = useSelector((state) => state.weekList);
  const { weeks } = weekList;

  const dayList = useSelector((state) => state.dayList);
  const { days } = dayList;

  useEffect(() => {
    dispatch(listYears());
  }, [dispatch, userInfo, history]);

  useEffect(() => {
    dispatch(listWeeks());
  }, [dispatch, userInfo, history]);

  useEffect(() => {
    dispatch(listDays());
  }, [dispatch, userInfo, history]);

  const [showHowItWorks, setShowHowItWorks] = useState(false);

  const logoutHandler = () => {
    dispatch(logout())
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      {showHowItWorks && (
        <HowItWorksModal
          mode="reference"
          onClose={() => setShowHowItWorks(false)}
        />
      )}
      <Header variant="light" active={true} />
      <main className="profile__menu--screen">
        <section className="profile-menu__tile">
          <a href="/my-account/security" className="profile-menu__item">
            <span>Passwords & Security</span>
            <span className="profile-menu__item-chevron">&rsaquo;</span>
          </a>
          <a href="/about-you" className="profile-menu__item">
            <span>About you</span>
            <span className="profile-menu__item-chevron">&rsaquo;</span>
          </a>
          <a href="/my-account/preferences" className="profile-menu__item">
            <span>Preferences</span>
            <span className="profile-menu__item-chevron">&rsaquo;</span>
          </a>
          <div className="profile-menu__item profile-menu__item--disabled">
            <span>Subscriptions & Billing</span>
            <span className="profile-menu__item-chevron">&rsaquo;</span>
          </div>
          <div
            className="profile-menu__item"
            onClick={() => setShowHowItWorks(true)}
          >
            <span>How it works</span>
            <span className="profile-menu__item-chevron">&rsaquo;</span>
          </div>
          <a href="/my-account/faqs" className="profile-menu__item">
            <span>Frequently Asked Questions</span>
            <span className="profile-menu__item-chevron">&rsaquo;</span>
          </a>
          <a href="/donate" className="profile-menu__item profile-menu__item--donate">
            <span>Support NoWastedDays</span>
            <span className="profile-menu__item-chevron">&rsaquo;</span>
          </a>
          <a href="/my-account/contact" className="profile-menu__item">
            <span>Contact Us</span>
            <span className="profile-menu__item-chevron">&rsaquo;</span>
          </a>
          <a href="/my-account/journal" className="profile-menu__item">
            <span>View Journal Log</span>
            <span className="profile-menu__item-chevron">&rsaquo;</span>
          </a>
          <a href="/my-account/my-data" className="profile-menu__item">
            <span>Manage my data</span>
            <span className="profile-menu__item-chevron">&rsaquo;</span>
          </a>
          <div className="profile-menu__item" onClick={logoutHandler}>
            <span>Logout</span>
            <span className="profile-menu__item-chevron">&rsaquo;</span>
          </div>
        </section>
      </main>
      <TestFooter />
    </>
  );
}
